import styled, { css } from "styled-components";
import { Col } from "react-bootstrap";

export const Title = styled.h1`
  margin-top: 1em;
  color: #1b3647;
  text-align: center;
  font-weight: bold;
  @media screen and (max-width: 576px) {
    font-size: 7vw;
  }
`;

export const SubTitle = styled(Title)`
  font-size: 1em !important;
  font-weight: 600;
  margin-bottom: 2em;
`;

export const BoxActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 3em;
  margin-top: 3em;
`;

export const BoxInputs = styled(BoxActions)`
  justify-content: center;
  flex-flow: column;
  width: 100%;
  margin-top: 50px;
  div {
    width: 40%;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
`;

export const ColCentered = styled(Col)`
  display: flex;
  justify-content: center;
`

export const ButtoPayment = styled.button`
  border: 1px solid #1b3647;
  border-radius: 8px;
  -webkit-box-shadow: none;
  box-shadow: none;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 1rem;
  height: 2.25em;
  -ms-flex-pack: start;
  justify-content: flex-start;
  line-height: 1.5;
  padding: calc(0.375em - 1px) calc(0.625em - 1px);
  position: relative;
  vertical-align: top;
  width: 100%;
  max-width: 400px;
  height: 60px;
  background-color: ${props => (props.selected ? "#1b3647" : "transparent")};
  @media screen and (max-width: 768px) {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  ${props => props.selected && css`
    svg {
      g {
        fill: white;
      }
    }
  `}
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 768px) {
    flex-flow: column;
  }
  :hover {
    background-color: #1b3647;
    p {
      color: white;
    }
    svg {
      g {
        fill: white;
      }
    }
  }
  p {
    color: ${props => (!props.selected ? "#1b3647" : "white")};
    letter-spacing: 1.5px;
    font-weight: 700;
    font-family: Open Sans;
    text-transform: uppercase;
    margin-bottom: 0px;
  }
  transition: background-color 200ms linear;
  hr {
    margin-top: 40px;
  }
`;

export const ButtoFinish = styled(ButtoPayment)`
  cursor: ${props => (props.selected ? "pointer" : "auto!important")};
  background-color: ${props => (props.selected ? "#1b3647" : "#f5f5f5")};
  border-color: ${props => (props.selected ? "#1b3647" : "#f5f5f5")};
  :hover {
    background-color: ${props => (props.selected ? "#1b3647" : "#f5f5f5")};
    p {
      color: white;
    }
  }
  p {
    color: white;
  }
`
export const ButtoAdd = styled(ButtoFinish)`
  svg {
    width: 25px; 
    path {
      fill: #f5f5f5;
    }
  }
  ${props => props.selected && css`
    svg {
      path {
        fill: white;
      }
    }
  `}
`;


export const BlackLine = styled.hr`
  background-color: #203a4b
`
